import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { Tag, TreeTag } from '#domains/tags/types';
import { env } from '#lib';
import dispatch from './dispatch';
import type { Action } from './types';

type State = {
  tags: Tag[];
  treeTags: TreeTag[];
};

type Actions = {
  setTags: (tags: Tag[]) => void;
  setTreeTag: (action: Action) => TreeTag[];
  setTreeTags: (treeTags: TreeTag[]) => void;
};

type TagsStore = State & Actions;

export const useTagsStore = create<TagsStore>()(
  devtools(
    set => {
      return {
        // State
        treeTags: [],
        treeTagsSnapshot: [],
        tags: [],

        // Actions
        setTags: tags => {
          set({ tags });
        },

        setTreeTag: action => {
          set(state => {
            return {
              ...state,
              treeTags: dispatch(state.treeTags, action)
            };
          });
        },

        setTreeTags: treeTags => {
          set({ treeTags });
        }
      };
    },
    { name: 'useTagsStore', enabled: env.isDev() }
  )
);
